import ExamForm from "../../components/ExamForm/ExamForm";
const AddNewExam = () => {
    return (
        <div style={{ marginTop: '3%' }}>
            <ExamForm type="Add" />
        </div>
    )
}
export default AddNewExam;